export const env = {env:'@DEPLOY-ENV@'};
